import React from 'react';
import { FieldFilter } from '../../filters';

interface Props {
  filter: FieldFilter;
  option: any;
}

export const CyWrapper: React.FC<Props> = ({ children, filter, option }) => {
  return (
    <span
      data-cy={`${filter?.field?.fieldLabel ?? '__new__'}.operations.${
        option.type
      }`}
      data-op="criteria.op_trigger"
      data-operation={`criteria.op_trigger.${filter.field.fieldName}`}
    >
      {children}
    </span>
  );
};
